import { getResponsiveValue } from '../get-responsive-value/get-responsive-value.js';
import { valueGetters } from '../value-getters/value-getters.js';
import { SYSTEM_PROPS } from '../system-props/system-props.js';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
function getSystemStyles(systemStyles, theme) {
    var systemProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : SYSTEM_PROPS;
    var styles = Object.keys(systemProps).reduce(function(acc, systemProp) {
        if (systemProp in systemStyles && systemStyles[systemProp] !== void 0) {
            acc.push(getResponsiveValue({
                value: systemStyles[systemProp],
                getValue: valueGetters[systemProps[systemProp].type],
                property: systemProps[systemProp].property,
                theme: theme
            }));
        }
        return acc;
    }, []);
    return styles.reduce(function(acc, stylesPartial) {
        Object.keys(stylesPartial).forEach(function(property) {
            if (typeof stylesPartial[property] === "object" && stylesPartial[property] !== null) {
                if (!(property in acc)) {
                    acc[property] = stylesPartial[property];
                } else {
                    acc[property] = __spreadValues(__spreadValues({}, acc[property]), stylesPartial[property]);
                }
            } else {
                acc[property] = stylesPartial[property];
            }
        });
        return acc;
    }, {});
}
export { getSystemStyles }; //# sourceMappingURL=get-system-styles.js.map
